/**
 * @file 更多列表数据
 * @author FengGuang(fengguang01@baidu.com)
 */
import {ITextCard} from '../../../../components/text-card/TextCard';

const learningPaddleData: ITextCard[] = [
    {
        title: '深度学习实战课',
        text: '我们为您提供了AI系统学习路径，助您从小白到大牛',
        link: 'https://aistudio.baidu.com/aistudio/course',
        target: '_blank',
        tagText: '去学习',
    },
    {
        title: '实操演练',
        text: '在 AI Studio 上实践您所学的内容',
        link: 'https://aistudio.baidu.com',
        target: '_blank',
        tagText: '去实践',
    }
];

export default learningPaddleData;
